// @ts-strict-ignore
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
	LocalProduct,
	RemoveLocalListProps,
	RemoveProductInLocalListProps,
	TAddProductRequest
} from '@/shared/types/deprecated-types'

export type InitialStateProps = {
	items: Record<string, LocalProduct[]>
}

const initialState: InitialStateProps = {
	items: {}
}

const localProductsList = createSlice({
	name: `localProductsList`,
	initialState,
	reducers: {
		// Adds service or accessor in local list
		addProductInLocalList: (state: InitialStateProps, action: PayloadAction<TAddProductRequest>) => {
			const { RELATED_PRODUCTS, TYPE_PRODUCTS, PRICE, ID, TITLE, KOD, SECTION_ID } = action.payload

			if (!state.items[RELATED_PRODUCTS]) {
				state.items[RELATED_PRODUCTS] = []
			}

			const localProductData: LocalProduct = {
				ID,
				TYPE_PRODUCTS,
				RELATED_PRODUCTS,
				PRICE,
				TITLE,
				KOD,
				SECTION_ID: typeof SECTION_ID === 'string' ? +SECTION_ID : SECTION_ID
			}

			state.items[RELATED_PRODUCTS].push(localProductData)
		},
		// Remove service or accessor in local list
		removeItemInLocalList: (state: InitialStateProps, action: PayloadAction<RemoveProductInLocalListProps>) => {
			const { RELATED_PRODUCTS, ID } = action.payload
			const filteredList = state.items[RELATED_PRODUCTS].filter(item => item.ID !== ID)

			state.items[RELATED_PRODUCTS] = [...filteredList]
		},
		removeLocalList: (state: InitialStateProps, action: PayloadAction<RemoveLocalListProps>) => {
			delete state.items[action.payload.ID]
		}
	}
})

export const { addProductInLocalList, removeItemInLocalList, removeLocalList } = localProductsList.actions

export default localProductsList.reducer
